import * as React from "react";
import { FC } from "react";
import { GlobalNotifications } from "./global-notifications";
import { JsonLD } from "@montana/shared/jsonld/jsonld.component";


export const Global: FC = React.memo(() =>
    <>
        <GlobalNotifications />
        <JsonLD />
    </>
);
